import { createDebouncer } from '~/js/utilities';
import { isQueryFilterEssential, normalizeFilterValue, prepareMerchandisingContent } from './utils';
// import { fetchProducts } from '~/js/utilities/products-and-collections';
import compare from 'just-compare';
import clone from 'just-clone';

const loadSwatches = () => {
  const normalizeSwatch = (swatch) => {
    if (swatch.color_image) return { image: swatch.color_image };
    if (swatch.color_gradient) return { gradient: swatch.color_gradient };
    return { color: swatch.color };
  };

  return Object.fromEntries(
    (window.COLOR_SWATCHES || []).map((swatch) => [
      swatch.heading,
      normalizeSwatch(swatch),
    ])
  );
};

const productsBrowser = (context, collectionHandle, mediaArray,idCollection,idCollectionDrop,disable_extension,collectionDropRelease,customer,goldOffset,silverOffset,baseWindow) => ({
  isLoading: false,
  isLoadingInitial: true,
  // data will be SearchSpring response
  // https://docs.searchspring.com/reference/get-search
  data: null,
  error: '',
  activeFacets: {},
  activeFacetsOld: {},
  sortId: '',
  sortIdOld: '',
  sortOptions: [],
  currentPage: 1,
  colorSwatches: loadSwatches(),
  loadId: 0,
  ignoreUpdates: false,
  filtersDesktopVisible: true,
  printCollectionsState: {},
  backToTopVisible: false,
  descriptionRevealed: false,
  preservedUrlParams: [
    // UTM parameters
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    
    // TikTok parameters
    'nb_platform', 'nbt', 'nb_placement', 'nb_campaign', 'nb_adgroup', 'nb_creative',
    
    // Facebook parameters
    'fbclid', 'fb_action_ids', 'fb_action_types', 'fb_source',
    
    // Google parameters
    'gclid', 'gclsrc', 'dclid', 'gbraid', 'wbraid',
    
    // Other common tracking parameters
    'ref', 'source', 'campaign', 'medium', 'term', 'content',
    'click_id', 'affiliate', 'partner', 'referrer',
    
    // Social media parameters
    'igshid', 'igrid', 'igsh', 'igshid', 'igshid',
    
    // Email marketing parameters
    'mc_cid', 'mc_eid', 'mc_tc', 'mc_cc', 'mc_si',
    
    // Custom tracking parameters (common prefixes)
    'tracking', 'track', 'analytics', 'stats', 'metric',
    
    // Shopify specific parameters
    'shopify_redirect', 'shopify_utm', 'shopify_source',
    
    // Generic marketing parameters
    'marketing', 'promo', 'discount', 'coupon', 'offer',
    
    // A/B testing parameters
    'ab_test', 'variant', 'experiment', 'test_id',
    
    // Retargeting parameters
    'retarget', 'remarket', 'pixel', 'conversion'
  ],

  get products() {
    return this.data.results || [];
  },

  get productsAndMerchandisingContent() {
    const { inline } = this.merchandisingContent;
    const { products } = this;

    return products.reduce((acc, product) => {
      const index = acc.length;
      const inlineContent = inline[index];
      if (inlineContent) acc.push({ inlineContent });
      acc.push({ product });
      return acc;
    }, []);
  },

  get facets() {
    return this.data.facets || [];
  },

  get merchandisingContent() {
    return prepareMerchandisingContent(this.data.merchandising.content);
  },

  get hasLoadMore() {
    const { pagination } = this.data;
    return pagination.currentPage < pagination.totalPages;
  },

  get hasNoActiveFacetsAndEmptyResults() {
    return (
      this.products.length === 0 &&
      Object.values(this.activeFacets).every((value) => !value.length)
    );
  },

  get isSearchAndHasNoActiveFacets() {
    return context === 'search-results' && this.data.filterSummary.length === 0;
  },

  get searchspringType() {
    return 'search';
  },

  async init() {
    this.debounceNextTick = createDebouncer(this.$nextTick.bind(this));
    this.monitorVisibility();
    this.mediaArray = mediaArray;

    if (collectionHandle == 'vip-shop-early') {
      window.localStorage.setItem("isVIP", true);
    }

    this.setStateFromUrl();
    try {
      await this.queryProducts();
    } finally {
      this.isLoadingInitial = false;
    }

    this.$watch(
      'activeFacets',
      this.debounceNextTick((value) => {
        // we have the code that in some cases updated the activeFacets immediately
        // so we wait one tick before fetching products

        if (this.ignoreUpdates) return;
        if (this.hasNoActiveFacetsAndEmptyResults) return;

        if (!compare(value, this.activeFacetsOld)) {
          this.currentPage = 1;
          this.queryProducts();
        }
        //this.validateCollectionDropRelease(false);
      })
    );

    this.$watch('ignoreUpdates', (value) => {
      if (value) {
        this.activeFacetsCopy = clone(this.activeFacets);
        this.sortIdCopy = this.sortId;
      } else {
        this.activeFacets = this.activeFacetsCopy;
        this.sortId = this.sortIdCopy;
      }
    });

    this.$watch('sortId', (value) => {
      if (value === this.sortIdOld) return;
      if (this.ignoreUpdates) return;

      this.queryProducts();
    });


    this.validateCollectionDropRelease(true);


  },
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  },

  validateCollectionDropRelease(initializeTimer) {
    
        console.log('Products Browser initialized', idCollection,idCollectionDrop,collectionDropRelease)

        if(disable_extension == false && collectionDropRelease && idCollection == idCollectionDrop) {
          const urlParams = new URLSearchParams(window.location.search);
          const isFacebookVIP = urlParams.get('facebook') === 'vip';
    
          if (isFacebookVIP) {
            const cookieName = 'userStatusFacebook';
            const cookieValue = 'VIP';
            const daysToExpire = 1;
    
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + daysToExpire);
    
            document.cookie = `${cookieName}=${cookieValue}; expires=${expirationDate.toUTCString()}; path=/`;
          }
    
                const getDateFromParts = (parts) => {
                  const getPart = (type) => parts.find(p => p.type === type)?.value;
    
                  const year = getPart("year");
                  const month = getPart("month");
                  const day = getPart("day");
                  const hour = getPart("hour");
                  const minute = getPart("minute");
                  const second = getPart("second");
    
                  return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
                }
    
                const getDateInCalifornia = () => {
                  const date = new Date();
                    const options = {
                      timeZone: "America/Los_Angeles",
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: false,
                    };
                    const timeInCalifornia = new Intl.DateTimeFormat("en-US", options).formatToParts(date);
                    return timeInCalifornia;
                }
    
                const getDropDate = () => {    
                  const utcDate = new Date(collectionDropRelease);
                  const edtDate = new Intl.DateTimeFormat("en-US", {
                    timeZone: "America/Los_Angeles",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false
                  })
                  return edtDate.formatToParts(utcDate); 
    
                } 
                /*
                const enableQuickAdd = () => {
                  const quickAddElements = document.querySelectorAll('.products-browser__products .product-card');
                  console.log("QUICK ADD ELEMENTS", quickAddElements.length);
                  quickAddElements.forEach((element) => {
                    const notifyMe = element.querySelector('.product-card__quickadd-button');
                    let isNotifyMe = false
                    if (notifyMe && notifyMe.textContent.includes('Notify Me')) {
                      notifyMe.classList.add("before-validations");
                      isNotifyMe = true;
                      if(!element.classList.contains("before-validations")) {
                        element.classList.add("before-validations")
                      }
                    }
                    if(isNotifyMe) {
                      const badges = element.querySelector('.product-card__badges');
                      if (badges) {
                        badges.remove();
                      }                        
                    }
                  });
                  quickAddElements.forEach((element) => {    
                    const quickAddButton = element.querySelector('.product-card__quickadd-button.quickAddTitleHidden');
                    if(quickAddButton){
                      quickAddButton.classList.remove("quickAddTitleHidden");
                    }
                  });

                }
                */
                const startCountdown = () => {
                  const originalDropDate = getDateFromParts(getDropDate());
                  const now = getDateFromParts(getDateInCalifornia());
                  //console.log("ORIGINAL DROP DATE", originalDropDate);
                  //console.log("CALIFORNIA", now);

                  const userStatus = this.getCookie('userStatusFacebook');
    
                  const earlyAccessOffset =
                    customer == "GOLD VIP" ? goldOffset :
                    customer == "SILVER VIP" || userStatus == "VIP" ? silverOffset :
                    0;
    
                  const adjustedDropDate = new Date(originalDropDate.getTime() - earlyAccessOffset);
                  const timeToShow = baseWindow - earlyAccessOffset;
                  const diff = adjustedDropDate - now;

                  if (diff > timeToShow) return;
                  let timerInterval;
                  
                  const updateTimer = () => {
                    const now = getDateFromParts(getDateInCalifornia());
                    const diff = adjustedDropDate - now;
                    if (diff <= 0) {
                      //document.getElementById("demo").textContent = "Drop is live!";
                      console.log("Drop is live!");
                      clearInterval(timerInterval);
                      //enableQuickAdd();
                      return;
                    }
    
                    const seconds = Math.floor((diff / 1000) % 60);
                    const minutes = Math.floor((diff / 1000 / 60) % 60);
                    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
                    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                    /*
                    document.getElementById("demo").textContent =
                      `${days}d ${hours}h ${minutes}m ${seconds}s`;
                    */
                   //console.log(`${days}d ${hours}h ${minutes}m ${seconds}s`)
                  };
    
                  updateTimer();
                  
                  if(initializeTimer){
                    timerInterval = setInterval(updateTimer, 1000);    
                  }
                };
                startCountdown();
        }
  },

  destroy() {
    this.intersectionObserver.disconnect();
  },

  async queryProducts({ loadMore = false } = {}) {
    const loadId = ++this.loadId;

    const { sortId, currentPage } = this;
    const searchParams = new URLSearchParams({
      resultsPerPage: 36,
      'bgfilter.ss_visible': 1,
      page: currentPage,
    });

    if (window.PRELAUNCH_STATE?.state) {
      searchParams.append('bgfilter.ss_prelaunch', 0);
    }

    if (context === 'collection') {
      searchParams.append('bgfilter.collection_handle', collectionHandle);
    } else if (context === 'search-results') {
      searchParams.append(
        'q',
        new URLSearchParams(window.location.search).get('q') || ''
      );
    }

    // Background Filter for country restriction
    if (window.SITE_LOCALE == 'en-ca') {
      searchParams.append('bgfilter.ss_country_us', 0);
    }
    else if (window.SITE_LOCALE != 'en-us') {
      searchParams.append('bgfilter.ss_country_us', 0);
      searchParams.append('bgfilter.ss_country_us_ca', 0);
    }

    const firstSort = this.sortOptions[0];
    if (sortId && (!firstSort || firstSort.id !== sortId)) {
      const [sortField, sortDirection] = sortId.split('::');
      searchParams.append(`sort.${sortField}`, sortDirection);
    }

    Object.entries(this.activeFacets).forEach(([key, value]) => {
      if (value && value.length) {
        const valueAsArray = Array.isArray(value) ? value : [value];
        valueAsArray.forEach((v) => {
          const [vType, ...vValue] = v.split('::');
          const vValueString = vValue.join('::');
          if (vType === 'range') {
            const { low, high } = JSON.parse(vValueString);
            searchParams.append(`filter.${key}.low`, low);
            searchParams.append(`filter.${key}.high`, high);
          } else {
            searchParams.append(`filter.${key}`, vValueString);
          }
        });
      }
    });

    this.activeFacetsOld = clone(this.activeFacets);
    this.sortIdOld = this.sortId;

    try {
      this.isLoading = true;
      this.error = '';

      // const data = await ssFetchSearchOrAutocomplete('search', searchParams);
      try {
        // await fetchProducts(data.results.map((product) => product.uid));
        throw new Error('Searchspring is not supported anymore.');
      } catch (e) {
        // if we fail here we'll retry and display error inside product card
        // eslint-disable-next-line no-console
        console.warn(e);
      }
      if (loadId !== this.loadId) return;
      const oldData = this.data;
      this.data = data;
      if (data.merchandising.redirect) {
        window.location.href = data.merchandising.redirect;
        await new Promise(() => {});
      }
      this.$dispatch('products-browser-data', { searchParams, data });
      if (loadMore) {
        const existingHandles = oldData.results.map(
          (product) => product.handle
        );
        this.data.results = [
          ...oldData.results,
          ...this.data.results.map((product) => {
            if (existingHandles.includes(product.handle)) {
              product.handleWithPage = `${currentPage}::${product.handle}`;
            }
            return product;
          }),
        ];
      }
      this.activeFacets = this.getActiveFacetsFromData();
      this.activeFacetsOld = clone(this.activeFacets);
      this.sortOptions = data.sorting.options.map((option) => ({
        ...option,
        id: `${option.field}::${option.direction}::${option.label}`,
      }));
      const currentSortOption =
        // reversing because multiple sort options can have the same field and
        // direction when using one as default sort order for merchandising
        // and we don't want to use the merchandising one
        [...this.sortOptions].reverse().find((option) => option.active) ||
        this.sortOptions[0];
      this.sortId = currentSortOption.id;
      this.sortIdOld = this.sortId;
      this.currentPage = data.pagination.currentPage;
      this.updateUrl(searchParams);
    } catch (e) {
      // TODO: analytics? sentry?
      this.error = e.message;
      // eslint-disable-next-line no-console
      console.warn(e);
      throw this.error;
    } finally {
      if (loadId === this.loadId) {
        this.isLoading = false;
      }
    }
  },

  getEmptyFacets() {
    return Object.fromEntries(
      this.data.facets.map((facet) => [facet.field, []])
    );
  },

  getActiveFacetsFromData() {
    const activeFacets = this.getEmptyFacets();

    this.data.filterSummary.forEach((filter) => {
      if (filter.field in activeFacets) {
        const { value } = filter;
        const normalizedValue = normalizeFilterValue(value);

        if (Array.isArray(activeFacets[filter.field])) {
          activeFacets[filter.field].push(normalizedValue);
        } else {
          // eslint-disable-next-line no-console
          console.warn(`Unexpected filter value: ${filter.field} ${value}`);
        }
      }
    });

    return activeFacets;
  },

  updateUrl(searchParams) {
    const url = new URL(window.location.href);
    const currentParams = new URLSearchParams(window.location.search);
    const params = new URLSearchParams();

    // Set the default query params based on current params
    Array.from(currentParams.entries()).forEach(([key, value]) => {
      if (!isQueryFilterEssential(key)) {
        params.set(key, value);
      }
    });

    // iterate each new param and check if already exist in current params
    searchParams.forEach((value, key) => {
        const isEssentialParam = isQueryFilterEssential(key);

      if (!isEssentialParam) {
        // Do not modify extra/non-filtering params (keep them as they are. ie UTMs)
        return;
      }
      
      if (key.startsWith('filter.'))  {
        // If the Query Param starts with `filter.`, it should be treated as a multi-value param
        const allSameKeys = Array.from(params.keys())
          .map(k => k.replace(/\[\d+\]$/, ''))
          .filter(k => k === key)
          .length;
        const alreadyExists = Array.from(params.entries()).some(([k, v]) => {
          const clearedKey = k.replace(/\[\d+\]$/, '');
          return clearedKey === key && v === value;
        });

        if (alreadyExists) {
          return;
        }
  
        if (allSameKeys >= 1) {
          params.append(`${key}[${allSameKeys}]`, value);
        } else {
          params.append(`${key}[0]`, value);
        }
        
        return;
      }

      // If the Query Param does not start with `filter.`, it should be treated as a single-value param
      params.set(key, value);
    });

    url.search = new URLSearchParams(params);
    window.history.pushState({}, '', url.toString());
  },

  setStateFromUrl() {
    const activeFacets = this.data ? this.getEmptyFacets() : {};
    this.currentPage = 1;

    const firstSort = this.sortOptions[0];
    if (firstSort) {
      this.sortId = firstSort.id;
    }

    Array.from(new URLSearchParams(window.location.search)).forEach(
      ([key, value]) => {
        if (key.startsWith('filter.')) {
          const field = key
            .replace('filter.', '')
            .replace('.low', '')
            .replace('.high', '')
            .replace(/\[(\d+)?\]$/, '');

          if (!activeFacets[field]) {
            activeFacets[field] = [];
          }

          if (key.endsWith('.low') || key.endsWith('.high')) {
            const type = key.endsWith('.low') ? 'low' : 'high';
            const appendToValue = { [type]: value };
            let currentValue =
              activeFacets[field][activeFacets[field].length - 1];
            const shouldAppend =
              currentValue?.startsWith('range::') &&
              !(currentValue.includes('low') && currentValue.includes('high'));

            if (shouldAppend) {
              currentValue = JSON.parse(currentValue.replace('range::', ''));
              currentValue = {
                ...currentValue,
                ...appendToValue,
              };
              activeFacets[field][
                activeFacets[field].length - 1
              ] = `range::${JSON.stringify(currentValue)}`;
            } else {
              activeFacets[field].push(
                `range::${JSON.stringify(appendToValue)}`
              );
            }
          } else {
            const valueNormalized = `value::${value}`;
            activeFacets[field].push(valueNormalized);
          }
        } else if (key.startsWith('sort.')) {
          const sortField = key.replace('sort.', '');
          const sortDirection = value;
          this.sortId = `${sortField}::${sortDirection}`;
        } else if (key === 'page') {
          // ignore page from url
          // this.currentPage = Number(value);
        }
      }
    );

    this.activeFacets = activeFacets;
  },

  handlePopstate() {
    this.setStateFromUrl();
  },

  loadMore() {
    this.currentPage += 1;
    //this.validateCollectionDropRelease(false);
    return this.queryProducts({ loadMore: true });
  },

  revealDescription() {
    this.descriptionRevealed = true;
  },

  collapseDescription() {
    this.descriptionRevealed = false;
  },

  clearAllFacets() {
    this.activeFacets = this.getEmptyFacets();
    this.queryProducts();
  },

  removeFilter(filter) {
    const normalizedValue = normalizeFilterValue(filter.value);
    if (Array.isArray(this.activeFacets[filter.field])) {
      this.activeFacets[filter.field] = this.activeFacets[filter.field].filter(
        (v) => v !== normalizedValue
      );
    } else {
      this.activeFacets[filter.field] = [];
    }
  },

  playCollectionVideo(media_id) {
    setTimeout(() => {
      const myVideo = document.querySelector(".products-browser__media--" + media_id + " video");
      if (myVideo) {
        myVideo.play();
      }
    }, 2000);
  },

  monitorVisibility() {
    let rootIntersecting = false;
    let ignoreBoxIntersecting = false;
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.$refs.backToTopIgnoreBox) {
            ignoreBoxIntersecting = entry.isIntersecting;
          } else {
            rootIntersecting = entry.isIntersecting;
          }
        });

        this.backToTopVisible = rootIntersecting && !ignoreBoxIntersecting;
      },
      { threshold: 0 }
    );
    this.intersectionObserver.observe(this.$root);
    this.intersectionObserver.observe(this.$refs.backToTopIgnoreBox);
  },

  handleBackToTopClick() {
    window.scrollTo({
      top: this.$root.offsetTop - document.querySelector('header').offsetHeight,
      behavior: 'smooth',
    });
  },
});

export default productsBrowser;
